/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobListFilter {
    getFixupPrototypeFunction() { return TemplateJobListFilter.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobListFilter>): TemplateJobListFilter {
        let obj = Object.assign(new TemplateJobListFilter(), model);
        TemplateJobListFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobListFilter>): TemplateJobListFilter {
        if (!model) return null;
        return TemplateJobListFilter.newInstance(<TemplateJobListFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobListFilter) {
        if (!obj) return;

        models.TemplateJobListFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobListFilter): boolean {
        Object.setPrototypeOf(obj, TemplateJobListFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Filter by statuses, execution_types, engine_types (the job's execution engine, stored internally as `type`), template_ids, service_account_ids, from_date, to_date, archived
     */
    query: models.QueryOperator;

    /**
     * Free-text search across job name, created_by, status, engine_type, execution_type and service account name; also matches jobs whose linked template name matches
     */
    search: string;

}
